import type { ChatRoomListResponsePage } from './chatRoomListResponsePage';

/**
 * 채팅방 목록 응답 데이터
 */
export interface ChatRoomListResponse {
  code?: string;
  message?: string;
  page?: ChatRoomListResponsePage;
  success?: boolean;
}
